export const NODE_ENV = process.env.APP_ENV || 'development';
export const SENTRY_DSN = process.env.SENTRY_DSN || '';
export const APP_MOCKING = process.env.APP_MOCKING || 'false';
export const APP_MOCKING_DEBUG = process.env.APP_MOCKING_DEBUG || 'false';
export const APP_API_URL = process.env.APP_API_URL || '';
